import { getAllAddress } from "../../helpers/address";

/**
 * Chuyển id trong JSON địa chỉ (addressDeliver) thành giá trị {label, value} cho các ô select.
 * Tên được tra từ cây tỉnh/xã-phường tĩnh (helpers/address).
 * Địa chỉ cũ (3 cấp, có district) dùng bộ mã cũ nên không tra được: trả về rỗng để chọn lại.
 */
export const getLocationSelectValues = async ({ province, ward, district } = {}) => {
  if (district) {
    return {};
  }
  const provinces = await getAllAddress();
  const foundProvince = provinces.find((e) => e.id === +province);
  const foundWard = foundProvince?.Wards.find((e) => e.id === +ward);
  const toOption = (item) => (item ? { value: item.id, label: item.name } : undefined);
  return {
    province: toOption(foundProvince),
    ward: toOption(foundWard),
  };
};
